import React, { useState, useEffect } from "react";
import {
  Box,
  Chip,
  Grid,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
} from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import {
  IconButtonComponent,
  SwitchButtonComponet,
  TextIconButtonComponent,
} from "../../../../component/atom";
import TableComponent from "../../../../component/atom/Table/TableComponent";
import DialogComponent from "../../../../component/atom/Dialog/Dialog";
import {
  AdminwebinarForm,
  PopUpMessageComponent,
} from "../../../../component/molecule";
import TextButtonComponet from "../../../../component/atom/Buttons/TextButton";
import { Actions } from "../../../../core/modules/Actions";
import { connect } from "react-redux";
import moment from "moment";
import { DATE_FORMAT, WEBINAR_STATUS, MARK_AS_COMPLETE } from "../../../../core/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { AdminSelectCoursesForm, AdminWebinarUpdateForm } from "../../../../component/molecule/Forms";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import _ from "lodash";
import WebinarCalendarView from "../../../../component/molecule/WebinarCalendarView";
import { renderTruncatedText } from "../../../../core/Constant";

const AdminWebinarMainScreen = ({
  adminWebinarList,
  getAdminWebinarList,
  getAdminWebinarStatus,
  deleteAdminWebinar,
  verifyToken,
  updateWebinarCompleteAdmin,
  addCourseToWebinar
}) => {
  const [viewMode, setViewMode] = useState("list");
  const [addwebinar, setAddWebinar] = useState(false);
  const [editWebinar, setEditWebinar] = useState(false);
  const [deleteWebinar, setDeleteWebinar] = useState(false);
  const [webinarList, setWebinarList] = useState([]);
  const [webinardetails, setWebinardetails] = useState({});
  const [webinarId, setWebinarId] = useState(0);
  const [webinarMessage, setWebinarMessage] = useState("");
  const [webinarAlert, setWebinarAlert] = useState(false);
  const [completeWebinar, setCompleteWebinar] = useState(false);
  const [completeWebinarId, setCompleteWebinarId] = useState(0);
  const [openCouse, setOpenCouse] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const isSuccess = location?.state?.isSuccess;

  useEffect(() => {
    const list = adminWebinarList.map((item) => {
      return { ...item, newTime: `${item?.time} ${item?.time_ext}` };
    });
    setWebinarList(list);
  }, [adminWebinarList]);

  useEffect(() => {
    getAdminWebinarList();
  }, []);

  useEffect(() => {
    if (isSuccess !== undefined) {
      if (parseInt(isSuccess)) {
        setWebinarMessage("Live class created successfully");
        setWebinarAlert(true);
      } else {
        setWebinarMessage("Live class created unsuccessfull");
        setWebinarAlert(true);
      }
    }
  }, []);

  const isActionDisabled = (status, isCompleted) => {
    return status === 0 || isCompleted === 1;
  };

  const editBtnPress = (id) => {
    const selected = webinarList.find((w) => w.id === id);
    if (selected && isActionDisabled(selected.status, selected.is_completed)) {
      return;
    }
    if (selected) setWebinardetails(selected);
    setEditWebinar(true);
  };

  const editCoursePress = (value, tableMeta) => {
    const selected = webinarList.find((w) => w.id === tableMeta.rowData[0]);
    if (selected) setWebinardetails(selected);
    setOpenCouse(true);
  };

  const updateWebinarStatus = (tableMeta) => {
  const targetId = tableMeta?.rowData[0];
  setWebinarList((prevList) =>
    prevList.map((webinar) => {
      if (webinar.id === targetId) {
        const updatedStatus = webinar.status === 1 ? 0 : 1;
        getAdminWebinarStatus({
          id: targetId,
          status: updatedStatus,
        });
        return { ...webinar, status: updatedStatus };
      }
      return webinar;
    })
  );
};

  const deleteSelectWebinar = (tableMetaOrId) => {
    const id = tableMetaOrId?.rowData?.[0] ?? tableMetaOrId;
    const selected = webinarList.find((w) => w.id === id);
    if (selected && isActionDisabled(selected.status, selected.is_completed)) {
      return;
    }
    setWebinarId(id);
    setDeleteWebinar(true);
  };

  const confirmDelete = () => {
    deleteAdminWebinar(webinarId);
    setDeleteWebinar(false);
  };

  const completeSelectWebinar = (id) => {
    setCompleteWebinarId(id);
    setCompleteWebinar(true);
  };

  const confirmClassCompleted = () => {
    updateWebinarCompleteAdmin({ id: completeWebinarId, is_completed: 1 });
    setCompleteWebinar(false);
  };

  const onMarkCompleted = (id)=>{
    updateWebinarCompleteAdmin({ id, is_completed: 1 });
  }

  const closeAddWebinarDialog = () => setAddWebinar(false);

  const allCourseNames = _.chain(webinarList)
    .flatMap("courses")
    .map("name")
    .compact()
    .uniq()
    .value();

  // --- Columns Config ---
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "date",
      label: "Date",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) =>
          moment(new Date(value)).format(DATE_FORMAT),
      },
    },
    {
      name: "newTime",
      label: "Time",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => value,
      },
    },
    {
      name: "duration",
      label: "Duration",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => value + " min",
      },
    },
    {
      name: "courses",
      label: "Course",
      options: {
        filter: true,
        sort: false,
        filterOptions: {
          names: allCourseNames, // Clean list of course names for the dropdown
          logic: (location, filterValue) => {
            if (!filterValue || filterValue.length === 0) return false;
            const courseNames = _.map(location, "name");
            return !filterValue.some((val) => courseNames.includes(val));
          },
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Grid spacing={2} rowGap={1}>
                {_.map(value, (item) => (
                  <Grid style={{ marginBottom: 2 }} key={`course_${item?.id}`}>
                      <Chip label={renderTruncatedText(item?.name, 20)} />
                    </Grid>
                  ))}
              </Grid>
              {tableMeta.rowData[7] === 0 && (
                  <IconButtonComponent
                    backgroundColor={'transparent'}
                    btnType={"editbtn"}
                    onclick={() => editCoursePress(value, tableMeta)}
                  />
                )}
            </>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const isCompleted = tableMeta.rowData[7];
          const isChecked = isCompleted === MARK_AS_COMPLETE.ON ? false : !!value;

          return (
            <Tooltip
              title={isCompleted === MARK_AS_COMPLETE.ON ? "Cannot change status of a completed class" : ""}
              disableHoverListener={isCompleted !== MARK_AS_COMPLETE.ON}
            >
              <span>
            <SwitchButtonComponet
              checked={isChecked}
                  disabled={isCompleted === MARK_AS_COMPLETE.ON}
              onChange={() => updateWebinarStatus(tableMeta)}
              inputProps={{ "aria-label": "controlled" }}
            />
              </span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "join_url",
      label: "Start",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
             <>
              {tableMeta?.rowData[7] === 0 ? (
                  <TextButtonComponet
                    text={"Start"}
                    onButtonClick={() => window.open(value, "_blank")}
                    isDisabled={tableMeta.rowData[5] === 0}
                  />
              ) : (
                <TextButtonComponet text={"End"} isDisabled={true} />
              )}
            </>
          ),
      },
    },
    {
      name: "is_completed",
      label: "Mark as Completed",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
            <>
              {value === 0 ? (
                  <TextButtonComponet
                    text={"Complete"}
                    onButtonClick={() =>
                    completeSelectWebinar(tableMeta.rowData[0])
                  }
                  isDisabled={tableMeta.rowData[5] === 0}
                />
              ) : (
                <CheckCircleIcon sx={{ color: "#28b882" }} fontSize={"large"} />
              )}
            </>
        ),
      },
    },
    {
      name: "edit",
      label: "Edit",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[5];
          const isCompleted = tableMeta.rowData[7];
          const disabled = isActionDisabled(status, isCompleted);

          const tooltipText = isCompleted === WEBINAR_STATUS.ON
            ? "Cannot edit completed class"
            : status === WEBINAR_STATUS.OFF
            ? "Enable status to edit class"
            : "";

          return (
            <Tooltip title={tooltipText} disableHoverListener={!disabled}>
              <Box
                component="span"
                sx={{
                  display: "inline-block",
                  pointerEvents: disabled ? "none" : "auto",
                  opacity: disabled ? 0.4 : 1,
                  cursor: disabled ? "not-allowed" : "pointer",
                }}
              >
                <IconButtonComponent
                  btnType={"editbtn"}
                  disabled={disabled}
                  onclick={() => editBtnPress(tableMeta.rowData[0])}
                />
              </Box>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "delete",
      label: "Delete",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[5];
          const isCompleted = tableMeta.rowData[7];
          const disabled = isActionDisabled(status, isCompleted);

          const tooltipText = isCompleted === WEBINAR_STATUS.ON
            ? "Cannot delete completed class"
            : status === WEBINAR_STATUS.OFF
            ? "Enable status to delete class"
            : "";

          return (
            <Tooltip title={tooltipText} disableHoverListener={!disabled}>
              <Box
                component="span"
                sx={{
                  display: "inline-block",
                  pointerEvents: disabled ? "none" : "auto",
                  opacity: disabled ? 0.4 : 1,
                  cursor: disabled ? "not-allowed" : "pointer",
                }}
              >
                <IconButtonComponent
                  btnType={"deleteIconbtn"}
                  disabled={disabled}
                  onclick={() => deleteSelectWebinar(tableMeta)}
                />
              </Box>
            </Tooltip>
          );
        },
      },
    },
  ];

  return (
    <>
      <Box className="main-screen-container" sx={{ p: 3 }}>
        <Grid container flexDirection={"column"} rowSpacing={3}>
          <Grid item>
            <Grid container justifyContent={"space-between"} alignItems={'center'}>
              <Grid item>
                <HeadingComponent
                  text={"Live Classes"}
                  fontweigth={600}
                  size={40}
                  fontfamily={"Montserrat"}
                  backNavigation={true}
                />
              </Grid>
              <Grid item>
                  <TextIconButtonComponent
                    icon={faPlusCircle}
                    btnText={"Add Class"}
                    size={"large"}
                    onclick={() => setAddWebinar(true)}
                  />
                </Grid>
            </Grid>
          </Grid>

          {/* View Mode Toggle Row */}
          <Grid item>
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, nextView) => nextView && setViewMode(nextView)}
              sx={{
                bgcolor: "#F2F4F7",
                p: "4px",
                borderRadius: "8px",
                "& .MuiToggleButton-root": {
                  border: "none",
                  borderRadius: "6px",
                  px: 2,
                  py: 0.75,
                  textTransform: "none",
                  fontWeight: 600,
                  color: "#667085",
                  "&.Mui-selected": {
                    bgcolor: "#FFFFFF",
                    color: "#101828",
                    boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1)",
                  },
                },
              }}
            >
              <ToggleButton value="list">List View</ToggleButton>
              <ToggleButton value="calendar">Calendar View</ToggleButton>
            </ToggleButtonGroup>
          </Grid>

          {/* Main Content Area */}
          <Grid item>
            {viewMode === "list" ? (
              <Box>
                <TableComponent columns={columns} data={webinarList} />
              </Box>
            ) : (
              <WebinarCalendarView
                webinarList={webinarList}
                onEditClass={editBtnPress}
                onDeleteClass={deleteSelectWebinar}
                getAdminWebinarList={getAdminWebinarList}
                onMarkCompleted={onMarkCompleted}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      {/* Popups & Dialogs */}
      <PopUpMessageComponent
        open={deleteWebinar}
        type={"other"}
        title={"Delete!"}
        message={"Are you sure you want to delete?"}
        btntext={"Yes, delete"}
        altbtntext={"No"}
        onclick={confirmDelete}
        altonclick={() => setDeleteWebinar(false)}
        onclose={() => setDeleteWebinar(false)}
      />

      <PopUpMessageComponent
        open={completeWebinar}
        type={"other"}
        title={"Complete!"}
        message={"Are you sure this live class is completed?"}
        btntext={"Yes, completed"}
        altbtntext={"No"}
        onclick={confirmClassCompleted}
        altonclick={() => setCompleteWebinar(false)}
        onclose={() => setCompleteWebinar(false)}
      />

      <PopUpMessageComponent
        open={webinarAlert}
        type={webinarAlert ? "success" : "error"}
        title={"Create Live Class"}
        message={webinarMessage}
        btntext={"OK"}
        onclick={() => setWebinarAlert(false)}
        onclose={() => setWebinarAlert(false)}
      />

      <DialogComponent
        title="Add Class"
        open={addwebinar}
        onClose={closeAddWebinarDialog}
        maxwidth={"md"}
      >
        {addwebinar && <AdminwebinarForm onClose={closeAddWebinarDialog} />}
      </DialogComponent>

      <DialogComponent
        title={"Edit Class"}
        open={editWebinar}
        onClose={() => setEditWebinar(false)}
        maxwidth={"md"}
      >
        <AdminWebinarUpdateForm
          open={editWebinar}
          webinarDetails={webinardetails}
          onClose={() => setEditWebinar(false)}
        />
      </DialogComponent>

      <DialogComponent
        title={"Edit Courses"}
        open={openCouse}
        onClose={() => setOpenCouse(false)}
      >
        <AdminSelectCoursesForm
          webinarDetails={webinardetails}
          onClose={() => setOpenCouse(false)}
        />
      </DialogComponent>
    </>
  );
};

export default connect(
  (state) => ({
    adminWebinarList: state.webinar.get("getAdminAllWebinarList"),
  }),
  {
    getAdminWebinarList: Actions.webinar.getAllWebinarsAdmin,
    getAdminWebinarStatus: Actions.webinar.updateWebinarAdminStatus,
    deleteAdminWebinar: Actions.webinar.deleteWebinarAdmin,
    verifyToken: Actions.auth.verifyToken,
    updateWebinarCompleteAdmin: Actions.webinar.updateWebinarCompleteAdmin,
    addCourseToWebinar: Actions.webinar.addCourseToWebinar,
  },
)(AdminWebinarMainScreen);
